import React from "react";
import Auth from "../views/dashboard/auth/sign-in";
import StudentAuth from "../components/Student/sign-in.js"
import UpdateUserForm from "../components/FormComponents/updateUserForm.js";
import { useLocation } from "react-router-dom";

const UpdateUserWrapper = () => {
  const location = useLocation();
  return <UpdateUserForm data={location.state?.userData} mode="edit" />;
};

export const SimpleRouter = [
  {
    path: "auth/sign-in",
    element: <Auth />,
  },

  {
    path: "auth/student/sign-in",
    element: <StudentAuth />,
  },
  
  {
    path: "users/update-user",
    element: <UpdateUserWrapper />,
  },




];
